module.exports = __webpack_public_path__ + "static/media/designprocess.a532f189.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/food/designprocess.jpeg
// module id = 83
// module chunks = 0